import {
  getGroupListMembersWidgetConfig,
  getWideGroupListAdminsWidgetConfig,
} from '../../UserWidgets.deviation_gruser/GroupList/widgetConfig';
import { getMyBadgesWidgetConfig } from '../../UserWidgets.deviation_gruser/MyBadges/widgetConfig';
import { getStatsWidgetConfig } from '../../UserWidgets.deviation_gruser/Stats/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';
import { getGroupAboutWidgetWideConfig } from '../../GroupWidgets.deviation_gruser/GroupAbout/widgetWideConfig';
import {
  getWideWatchersWidgetConfig,
  getWideWatchingWidgetConfig,
} from '../../UserWidgets.deviation_gruser/WatchedDeviants/widgetConfig';
import { getWideAboutMeWidgetConfig } from '../../UserWidgets.deviation_gruser/AboutMe/widgetConfig';
import { getMyCommentsWidgetConfig } from '../../UserWidgets.deviation_gruser/MyComments/widgetConfig';

export const getAboutSectionWidgetConfigs = ({ t, dispatch }) => ({
  coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  groupAbout: getGroupAboutWidgetWideConfig({ t, dispatch }),
  about: getWideAboutMeWidgetConfig({ t, dispatch }),
  userstats: getStatsWidgetConfig({ t, dispatch }),
  groupListAdmins: getWideGroupListAdminsWidgetConfig({ t, dispatch }),
  groupListMembers: getGroupListMembersWidgetConfig({ t, dispatch }),
  badgesActivity: getMyBadgesWidgetConfig({ t, dispatch }),
  watching: getWideWatchingWidgetConfig({ t, dispatch }),
  watchers: getWideWatchersWidgetConfig({ t, dispatch }),
  myComments: getMyCommentsWidgetConfig({ t, dispatch }),
});
